export function SaveInformation(this: any): any {
  return {
    debtorNo: this.debtorNo,
    status: this.status,
    information: this.informationList,
  };
}
